import React from 'react';
import { appBundleReadyMark } from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import type { BM3Metric } from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/types.tsx';
import { JsmPageInteractiveEvent } from '@atlassian/jira-servicedesk-common/src/utils/browser-metric/index.tsx';

type ConnectedReadyForUserProps = {
	metricKey?: string;
	metric: BM3Metric;
};

const ConnectedReadyForUser = ({ metricKey, metric }: ConnectedReadyForUserProps) => (
	<JsmPageInteractiveEvent
		metricKey={metricKey}
		withMarks={[appBundleReadyMark]}
		appName="servicedesk.knowledge.hub"
		metric={metric}
	/>
);

export default ConnectedReadyForUser;
